<template>
  <div>
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <h4 class="mt-0 mb-2">SALDO HARIAN</h4>
        <div class="ml-3 mb-2">
            <el-date-picker
                v-model="tanggal"
                type="date"
                placeholder="Pick a day"
                value-format="yyyy-MM-dd"
                size="small"
                :clearable="false"
                style="cursor: pointer;"
                :picker-options="pickerOptions">
            </el-date-picker>
        </div>
      </div>

      <div class="col-md-12">
        <el-card shadow="none" class="box-card card-saldo-harian col-md-12 mb-4 p-0" :body-style="{ paddingLeft: '0px', paddingRight: '0px', paddingTop:'0px' }">

          <div class="table-container-daily-balance">
            <table class="border border-gray-400 text-sm w-100 fixed-header-table hover-table daily-balance">
              <thead>
                <tr class="bg-gray-300 text-center">
                  <th class="border border-gray-400" rowspan="2">No</th>
                  <th class="border border-gray-400" rowspan="2">Bank Name</th>
                  <th class="border border-gray-400" rowspan="2">Curr</th>
                  <th class="border border-gray-400" rowspan="2">Account Number</th>
                  <th class="border border-gray-400" colspan="2">Opening Balance (Jt)</th>
                  <th class="border border-gray-400" colspan="2">Receipt (Jt)</th>
                  <th class="border border-gray-400" colspan="2">Payment (Jt)</th>
                  <th class="border border-gray-400" colspan="2">Ending Balance (Jt)</th>
                </tr>
                <tr class="bg-gray-300 text-center">
                  <th class="border border-gray-400">USD</th>
                  <th class="border border-gray-400">IDR</th>
                  <th class="border border-gray-400">USD</th>
                  <th class="border border-gray-400">IDR</th>
                  <th class="border border-gray-400">USD</th>
                  <th class="border border-gray-400">IDR</th>
                  <th class="border border-gray-400">USD</th>
                  <th class="border border-gray-400">IDR</th>
                </tr>
              </thead>
              <tbody v-if="flattenedSections.length">
                <tr
                    v-for="item in flattenedSections"
                    :key="item.key"
                    :style="item.type === 'summary' ? 'font-weight: bold; background: #eee;' : ''"
                    :class="item.type === 'summary' ? 'db-section' : ''"
                >
                    <template v-if="item.type === 'summary'">
                    <td colspan="4" class="bg-td-section">{{ item.section }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.opening_balance_usd) }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.opening_balance_idr) }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.receipt_usd) }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.receipt_idr) }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.payment_usd) }}</td>
                    <td class="bg-td-section text-right" style="color:red;">- {{ formatNumber(item.summary.payment_idr) }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.ending_balance_usd) }}</td>
                    <td class="bg-td-section text-right">{{ formatNumber(item.summary.ending_balance_idr) }}</td>
                    </template>

                    <template v-else>
                    <td>{{ item.no }}</td>
                    <td :class="['10108085271', '0127081808001', '6890522970', '6890523071'].includes(item.account_number) ? 'bg-pink-light' : ''">
                        {{ item.bank_name }}
                    </td>
                    <td>{{ item.currency }}</td>
                    <td class="text-right">{{ item.account_number }}</td>
                    <td class="text-right">{{ formatNumber(item.opening_balance_usd) }}</td>
                    <td class="text-right bg-yellow-light">{{ formatNumber(item.opening_balance_idr) }}</td>
                    <td class="text-right">{{ formatNumber(item.receipt_usd) }}</td>
                    <td class="text-right bg-yellow-light">{{ formatNumber(item.receipt_idr) }}</td>
                    <td class="text-right">{{ formatNumber(item.payment_usd) }}</td>
                    <td class="text-right bg-yellow-light" style="color:red;">-{{ formatNumber(item.payment_idr) }}</td>
                    <td class="text-right">{{ formatNumber(item.ending_balance_usd) }}</td>
                    <td class="text-right">{{ formatNumber(item.ending_balance_idr) }}</td>
                    </template>
                </tr>
                </tbody>

                <tfoot>
                    <tr style="font-weight: bold; background: #d3d3d3">
                        <td colspan="4" class="text-center bg-foot">TOTAL</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.opening_balance_usd) }}</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.opening_balance_idr) }}</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.receipt_usd) }}</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.receipt_idr) }}</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.payment_usd) }}</td>
                        <td class="text-right bg-foot" style="color:red;">-{{ formatNumber(overallSummary.payment_idr) }}</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.ending_balance_usd) }}</td>
                        <td class="text-right bg-foot">{{ formatNumber(overallSummary.ending_balance_idr) }}</td>
                    </tr>
                </tfoot>
            </table>

             <Loader v-if="loading.table"/>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Config,Penanggalan, AxiosWithJar, FuelColor, Rainbow, Rainbow2, AppColors } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default {
    components:{
		Loader,
	},
    data() {
        return {
            responsedata:[],
            rawData:[],
            /*
            //Sample data
            rawData: [
                {
                    section: "Operational Account",
                    data: [
                        { no: 1, bank_name: "BCA BRIGHT", currency: "IDR", account_number: "2050000292", opening_balance_usd: null, opening_balance_idr: 28, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 4, ending_balance_usd: null, ending_balance_idr: 24 },
                        { no: 2, bank_name: "BCA PEMBIAYAAN", currency: "IDR", account_number: "2050005936", opening_balance_usd: null, opening_balance_idr: 1170, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 1170 },
                        { no: 3, bank_name: "BCA UTAMA", currency: "IDR", account_number: "353109526", opening_balance_usd: null, opening_balance_idr: 178290, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 78980, ending_balance_usd: null, ending_balance_idr: 99310 },
                        { no: 4, bank_name: "BNI UTAMA", currency: "IDR", account_number: "1557276773", opening_balance_usd: null, opening_balance_idr: 847, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 847 },
                        { no: 5, bank_name: "BRI CASH CARD", currency: "IDR", account_number: "037801001813302", opening_balance_usd: null, opening_balance_idr: 75834, receipt_usd: null, receipt_idr: 48135, payment_usd: null, payment_idr: 89464, ending_balance_usd: null, ending_balance_idr: 34504 },
                        { no: 6, bank_name: "MANDIRI UTAMA", currency: "IDR", account_number: "1190004659049", opening_balance_usd: null, opening_balance_idr: 22674, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 10127, ending_balance_usd: null, ending_balance_idr: 12548 },
                        { no: 7, bank_name: "BSI OPERASIONAL", currency: "IDR", account_number: "7811211278", opening_balance_usd: null, opening_balance_idr: 10441, receipt_usd: null, receipt_idr: 1040, payment_usd: null, payment_idr: 9, ending_balance_usd: null, ending_balance_idr: 11471 }
                    ]
                },
                {
                    section: "Non Operational Account",
                    data: [
                        { no: 8, bank_name: "BCA OPR BRIGHT/SPBB", currency: "IDR", account_number: "2050000314", opening_balance_usd: null, opening_balance_idr: 43, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 43 },
                        { no: 9, bank_name: "BCA EDC BRIGHT", currency: "IDR", account_number: "2050000900", opening_balance_usd: null, opening_balance_idr: 755, receipt_usd: null, receipt_idr: 88, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 843 },
                        { no: 10, bank_name: "BCA Penampungan", currency: "IDR", account_number: "2050001281", opening_balance_usd: null, opening_balance_idr: 120558, receipt_usd: null, receipt_idr: 65162, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 185720 },
                        { no: 11, bank_name: "BCA EDC", currency: "IDR", account_number: "0353109534", opening_balance_usd: null, opening_balance_idr: 50273, receipt_usd: null, receipt_idr: 12177, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 62449 },
                        { no: 12, bank_name: "BNI PENDANAAN", currency: "IDR", account_number: "155727675", opening_balance_usd: null, opening_balance_idr: 10, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 10 },
                        { no: 13, bank_name: "BNI EDC", currency: "IDR", account_number: "757573731", opening_balance_usd: null, opening_balance_idr: 3950, receipt_usd: null, receipt_idr: 799, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 4748 },
                        { no: 14, bank_name: "BNI OPR", currency: "IDR", account_number: "7575737357", opening_balance_usd: null, opening_balance_idr: 4363, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 4363 },
                        { no: 15, bank_name: "BRI PENAMPUNGAN", currency: "IDR", account_number: "037801001814308", opening_balance_usd: null, opening_balance_idr: 217, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 217 },
                        { no: 16, bank_name: "MANDIRI PEMBIAYAAN", currency: "IDR", account_number: "1030005869843", opening_balance_usd: null, opening_balance_idr: 285, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 285 },
                        { no: 17, bank_name: "MANDIRI CAFE BRIGHT", currency: "IDR", account_number: "1030005674391", opening_balance_usd: null, opening_balance_idr: 389, receipt_usd: null, receipt_idr: 27, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 416 },
                        { no: 18, bank_name: "MANDIRI PENDANAAN/CASH CARD", currency: "IDR", account_number: "1030005994468", opening_balance_usd: null, opening_balance_idr: 5067, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 27, ending_balance_usd: null, ending_balance_idr: 5041 },
                        { no: 19, bank_name: "MANDIRI BRIGHT / E-MONEY", currency: "IDR", account_number: "1190005070378", opening_balance_usd: null, opening_balance_idr: 8833, receipt_usd: null, receipt_idr: 3554, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 12387 },
                        { no: 20, bank_name: "MANDIRI EDC", currency: "IDR", account_number: "1190004853220", opening_balance_usd: null, opening_balance_idr: 3912, receipt_usd: null, receipt_idr: 827, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 4739 },
                        { no: 21, bank_name: "MANDIRI Voucher", currency: "IDR", account_number: "1030007231026", opening_balance_usd: null, opening_balance_idr: 733, receipt_usd: null, receipt_idr: 80, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 813 },
                        { no: 22, bank_name: "BTN PENAMPUNGAN", currency: "IDR", account_number: "0001401300020315", opening_balance_usd: null, opening_balance_idr: 906686, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 906686 },
                        { no: 23, bank_name: "DKI UTAMA", currency: "IDR", account_number: "10108085271", opening_balance_usd: null, opening_balance_idr: 3701, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 3701 },
                        { no: 24, bank_name: "BJB PENAMPUNGAN", currency: "IDR", account_number: "0127081808001", opening_balance_usd: null, opening_balance_idr: 4, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 4 },
                        { no: 25, bank_name: "BCA Alfamart Depok", currency: "IDR", account_number: "6890522970", opening_balance_usd: null, opening_balance_idr: 0, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 0 },
                        { no: 26, bank_name: "BCA Alfamart Sunter", currency: "IDR", account_number: "6890523071", opening_balance_usd: null, opening_balance_idr: 6, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 6 },
                        { no: 27, bank_name: "BNI CASH CARD (SPD)", currency: "IDR", account_number: "1557272724", opening_balance_usd: null, opening_balance_idr: 391, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 43, ending_balance_usd: null, ending_balance_idr: 348 },
                        { no: 28, bank_name: "MANDIRI DC JAKARTA", currency: "IDR", account_number: "1030006233940", opening_balance_usd: null, opening_balance_idr: 202, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 202 },
                        { no: 29, bank_name: "MANDIRI DOLLAR", currency: "USD", account_number: "1030005551128", opening_balance_usd: 49.08, opening_balance_idr: 0, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: 49.08, ending_balance_idr: 0 }
                    ]
                },
                {
                    section: "Notional Pooling Account",
                    data: [
                        { no: 30, bank_name: "BRI EDC", currency: "IDR", account_number: "37801000337303", opening_balance_usd: null, opening_balance_idr: 91, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 91 },
                        { no: 31, bank_name: "MANDIRI PENAMPUNGAN", currency: "IDR", account_number: "1030005758442", opening_balance_usd: null, opening_balance_idr: 38431, receipt_usd: null, receipt_idr: 4255, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 42686 }
                    ]
                },
                {
                    section: "Deposito Account",
                    data: []
                },
                {
                    section: "Cash On Hand",
                    data: [
                        { no: 32, bank_name: "Cash On Hand", currency: "IDR", account_number: "", opening_balance_usd: null, opening_balance_idr: 0, receipt_usd: null, receipt_idr: 0, payment_usd: null, payment_idr: 0, ending_balance_usd: null, ending_balance_idr: 0 }
                    ]
                }
            ],
            */

            //sectionsWithSummary: [],
            tanggal: Penanggalan().sekarang,
            loading: {
                table: false,
                isSuccess: false,
            },

            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: 'Today',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: 'Yesterday',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }, {
                    text: 'A week ago',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                    }
                }]
            },
        }
    },
    watch: {
        tanggal(newVal, oldVal) {
            this.getData();
        }
    },
    mounted() {
        this.getData();
    },

    created() {
        /*
        this.sectionsWithSummary = this.rawData.map(section => {
            const data = Array.isArray(section.data) ? section.data : []
            return {
                section: section.section,
                data,
                summary: this.calculateSummary(data)
            }
        }) */
    },
    computed: {
        sectionsWithSummary() {
            return this.rawData.map(section => {
            const data = Array.isArray(section.data) ? section.data : []
            return {
                section: section.section,
                data,
                summary: this.calculateSummary(data)
            }
            })
        },
        overallSummary() {
            const result = {
                opening_balance_usd: 0,
                opening_balance_idr: 0,
                receipt_usd: 0,
                receipt_idr: 0,
                payment_usd: 0,
                payment_idr: 0,
                ending_balance_usd: 0,
                ending_balance_idr: 0
            };

            this.sectionsWithSummary.forEach(section => {
                for (const key in result) {
                    const val = section.summary[key];
                    result[key] += typeof val === 'number' ? val : 0;
                }
            });

            return result;
        },
        flattenedSections() {
            return this.sectionsWithSummary.flatMap((section, sectionIndex) => {
                const rows = section.data.map((item, itemIndex) => ({
                    type: 'data',
                    key: `section-${sectionIndex}-row-${itemIndex}`,
                    ...item
                }))
                return [
                    {
                        type: 'summary',
                        key: `summary-${sectionIndex}`,
                        section: section.section,
                        summary: section.summary
                    },
                    ...rows
                ]
            })
        },
    },

    methods: {
        async getData() {
            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/treasury/saldoharian?'

            this.urlRequestParams+='&date='+this.tanggal
            //this.urlRequestParams+='&year='+this.filter.year
            //this.urlRequestParams+='&month='+this.filter.month
            //this.urlRequestParams+='&type='+this.filter.type
            //
            this.loading.table = true
            this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{
                    this.responsedata = response.data;
                    this.loading.isSuccess = true;

                    this.rawData = response.data.data;

                    //console.log('saldo harian: ' + JSON.stringify(this.rawData));
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.table = false;
                })
        },

        formatNumber(value) {
            if (value === null || value === undefined || value === 0) return '-'
            return new Intl.NumberFormat('id-ID').format(value)
        },

        calculateSummary(data) {
            const result = {
                opening_balance_usd: 0,
                opening_balance_idr: 0,
                receipt_usd: 0,
                receipt_idr: 0,
                payment_usd: 0,
                payment_idr: 0,
                ending_balance_usd: 0,
                ending_balance_idr: 0
            }

            data.forEach(row => {
                for (const key in result) {
                    const val = parseFloat(row[key])
                    result[key] += isNaN(val) ? 0 : val
                }
            })
            /*
            data.forEach(row => {
                for (const key in result) {
                    const val = row[key]
                    result[key] += typeof val === 'number' ? val : 0
                }
            }) */

            return result
        },
    }
}
</script>


<style>
.daily-balance td {
  padding: 4px 8px !important;
  border: 1px dashed #C0E6F5;
}

.daily-balance th {
  padding: 6px 8px !important;
  background: #0B3040;
  color: white;
  border: 1px dashed white;
}

.bg-td-section {
    background: #C0E6F5;
}

.bg-foot {
    background: #44B3E1;
}

.hover-table tr:hover td {
  background-color: #f0f0f0;
  cursor: pointer;
}

table.fixed-header-table {
  border-collapse: collapse;
  border-spacing: 0;
}

.table-container-daily-balance {
  max-height: calc(100vh - 155px);
  overflow-y: auto;
  border: 1px solid #ccc;
}

.fixed-header-table {
  border-collapse: collapse;
  width: 100%;
}

.fixed-header-table thead {
  position: sticky;
  top: 0;
  background-color: #f3f3f3;
  z-index: 1;
}

.fixed-header-table th,
.fixed-header-table td {
  padding: 6px;
  min-width: 50px;
  white-space: nowrap;
}

.bg-yellow-light {
    background: #FFFFCC;
}

.bg-pink-light {
    background: #F2CEEF;
}

.card-saldo-harian .el-card__body, .el-main {
    padding: 0px !important;
}

</style>
